import React, { Component } from 'react'
import _ from 'underscore'
import { mixinsClassName, createAvatarElement } from '../../utils'
import Normal from './normal';

export default class Avatar extends Component {
    render() {
        const { type } = this.props
        let props = _.clone(this.props)
        props.className = mixinsClassName("ui-avatar", type ? `ui-avatar-${type}` : null, props)
        props = _.extend({
            width: 30,
            height: 30
        }, props);

        switch (type) {
            case "normal":
                return <Normal {...props} />
            default:
                return createAvatarElement(props)
        }

    }
}


// WEBPACK FOOTER //
// ./src/ui/avatar/index.js